import { Car, Zap, UtensilsCrossed, Pill, Beaker, Settings, FileText, Fuel, Mountain, Droplets, LucideIcon } from "lucide-react";

export interface IndustryBase {
  slug: string;
  icon: LucideIcon;
}

export const industriesData: IndustryBase[] = [
  { slug: "automotive-ev", icon: Car },
  { slug: "renewable-energy", icon: Zap },
  { slug: "food-beverage", icon: UtensilsCrossed },
  { slug: "pharmaceuticals-biotech", icon: Pill },
  { slug: "chemicals-petrochemicals", icon: Beaker },
  { slug: "general-manufacturing", icon: Settings },
  { slug: "pulp-paper-packaging", icon: FileText },
  { slug: "oil-gas", icon: Fuel },
  { slug: "mining-extraction", icon: Mountain },
  { slug: "water-wastewater", icon: Droplets },
];
